import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const defaultFaqs = [
  { q: "How do I receive my PDF?", a: "The moment your payment is confirmed, you'll get instant on-screen download links plus an email with your files. No waiting." },
  { q: "Can I access it forever?", a: "Yes. Every purchase includes lifetime access. Your download links stay tied to your order so you can re-download anytime." },
  { q: "Can I read it on my phone?", a: "Absolutely. Our guides are standard PDFs that open beautifully on phones, tablets, laptops and e-readers." },
  { q: "Is it updated?", a: "Yes. Guides receive regular updates, and you'll always have access to the latest version at no extra cost." },
];

export const FaqAccordion = ({ faqs = defaultFaqs }) => (
  <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
    {faqs.map((f, i) => (
      <AccordionItem key={i} value={`item-${i}`} className="border-black/10">
        <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg tracking-tight hover:no-underline py-6">
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="text-base leading-relaxed text-muted-foreground pb-6">
          {f.a}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
